module.exports = __webpack_public_path__ + "static/media/backdrop.7050841a.png";